import { useTranslation } from 'react-i18next'
import { KIND } from 'baseui/button'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

const useZohoClientDataImporter = fetchZohoClient => {
  const { t } = useTranslation()
  const isPulse = usePulseScope()

  const handleClick = async e => {
    e.preventDefault()
    const confirmation = confirm(t('subscriptionForm:customer_module.zoho_client_fetcher.confirmation'))
    if (!confirmation) {
      return
    }
    fetchZohoClient()
  }

  return { t, buttonKind: isPulse ? KIND.secondary : undefined, handleClick }
}

export default useZohoClientDataImporter
